import "bootstrap/dist/css/bootstrap.min.css";
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/themes/base/theme.css';
import "./app.scss";
import { register } from "register-service-worker";
require('vue2-autocomplete-js/dist/style/vue2-autocomplete.css')

window.app_name = 'Din Raft';
window.api_url = "https://market-app.boardiacs.com";

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import "bootstrap";

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from './router'

Vue.config.productionTip = false;

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

new Vue({
    mounted() {
        this.enableInterceptor()

        router.beforeEach((to, from, next) => {
            document.title = to.meta.title ? to.meta.title : app_name
            next() 
        })
    },
    methods: {
      enableInterceptor() {
        window.axios.interceptors.response.use(
            response => {
                return response;
            }, 
            async error => {
                const status = error.response ? error.response.status : null;
                if (status !== 401) {
                  return Promise.reject(error);
                } 
          }
        );
      }
    },
    router,
    store,
    render: h => h(App)
}).$mount("#app");

if (process.env.NODE_ENV === "production") {
    register(`${process.env.BASE_URL}serviceWorker.js`, {
        ready() {
        console.log(
            "App is being served from cache by a service worker."
        );
        },
        registered() {
        console.log("Service worker has been registered.");
        },
        cached() {
        console.log("Content has been cached for offline use.");
        },
        updatefound() {
        console.log("New content is downloading.");
        },
        updated() {
        console.log("New content is available; please refresh.");
        //window.location.reload();
        },
        offline() {
        console.log(
            "No internet connection found. App is running in offline mode."
        );
        },
        error(error) {
        console.error("Error during service worker registration:", error);
        }
    });
}
